import React, { useState, useEffect } from 'react'
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import SearchGrid from '../../components/table/SearchGrid'
import Breadcrums from '../../components/BreadCrums/breadcrums';
import TopSpacer from '../../components/Common/spacer/TopSpacer';

import TotalIcon from "../../assets/img/icons/total.svg";
import SubscribedIcon from "../../assets/img/icons/trackingDelivered.svg";
import UnsubscribedIcon from "../../assets/img/icons/trackingVoid.svg";

import { PostDataAPI } from '../../Services/APIService';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import Loader from "../../components/Loader/Loader";
import { ActionDialog } from "../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../components/Message/Alert";
//import AddProgram from './components/AddProgram';
//import ChangeDocument from './changeDocument/ChangeDocument';
import ClearIcon from '@material-ui/icons/Clear';
import PrintIcon from './../../images/icons/PrintIcon.png';
import { formateMdnNumber, getFormatedDate, formatDate, formatDateTime } from '../../../src/components/Common/Extensions';
import { Table, TableRow, Collapse, Empty, Dropdown, message, Menu, Typography, Tag } from 'antd';
import { GetUserInfo } from '../../Services/GetUserInfo';


function Subscribers({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const objLoggedInUser = JSON.parse(GetUserInfo())?.user;
    const [loggedInUserName] = useState(objLoggedInUser?.firstName + ' ' + objLoggedInUser.lastName);


    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


    const [state, setState] = useState({
        confirmed: '', shipped: '', inTransit: '', delivered: '', returned: '',
        claimed: '', voided: '', deleted: ''
    });
    const [isLoading, setIsLoading] = useState(false);



    const applicationsStatusBoxes = [
        {
            value: 'Total',
            status: 'Total',
            numbers: '00',
            Icon: TotalIcon,
        },
        {
            value: 'Subscribed',
            status: 'Subscribed',
            numbers: '00',
            Icon: SubscribedIcon,

        },
        {
            value: 'Unsubscribed',
            status: 'Unsubscribed',
            numbers: '00',
            Icon: UnsubscribedIcon,
        }
    ]

    const [applicationsData, setApplicationsData] = useState([]);

    const triggerMenu = (type) => {
        if (filteredApplicationsData && filteredApplicationsData.length > 0) {
            const subscriberIds = filteredApplicationsData.map(item => item.subscriberId);
            const postData = {
                applicationIds: subscriberIds,
                type: '',
                applicationType: ''
            };
            setIsLoading(true);
            PostDataAPI("fdnsubscriber/exportApplications", postData).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    if (type == 'print' || type == 'pdf') {
                        handlePrint(result.data);
                    } else {
                        window.open("." + result.data, "_blank")
                    }

                } else {

                }
            })
        } else {
            showMessage("Error", "No record exists", "error", 3000);
        }


    }
    const exportList = () => {
        let filteredData = [];
        const trimmedValue = searchFilter.trim()
        filteredData = [...filteredApplicationsData];
        filteredData = filteredData.filter(entry => {
            var hasValue = false;
            for (var prop in entry) {
                if (Object.prototype.hasOwnProperty.call(entry, prop)) {
                    hasValue = entry[prop]?.toString().toLowerCase().includes(trimmedValue.toLowerCase());
                    if (hasValue)
                        break;
                }
            }
            return hasValue;
        });
        if (filteredData && filteredData.length > 0) {
            const subscriberIds = filteredData.map(item => item.subscriberId);
            const postData = {
                type: '',
                applicationIds: subscriberIds,
                applicationType: ''
            };
            setIsLoading(true);
            PostDataAPI("fdnsubscriber/exportApplications", postData).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    window.open("." + result.data, "_blank");
                }
                else {
                    showMessage("Error", "No record exists", "error", 3000);
                }
            });
        }
        else {
            showMessage("Error", "No record exists", "error", 3000);
        }
    }


    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;

        if (currValue.trim() === "" && currValue !== "") {
            return;
        }
        //    const trimedValue = currValue.trim()

        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const handleActionClick = (key, item) => {
        switch (key) {

            //case 'Approved':
            //    approveApplicationForm(item, key);
            //    break;
            //case 'Rejected':
            //    rejectApplicationForm(item.applicationId, key);
            //    break;
            //case 'preview':
            //    OpenPreviewDialog(item)
            //    break;
            //case 'edit':
            //    editAppProgram(item);
            //    break;
            default:
                break;
        }

    }
    //const approveApplicationForm = (item, key) => {
    //    showActionDialog('Are you sure you want to approve this application?', "confirm", function () {
    //        var isForOrlando = false;
    //        var eventLocation = "";
    //        var eventDate = "";
    //        var mapImage = "";
    //        var mapPath = "";
    //        if (lstOrlandoZipCodes.some(zip => zip == item.zip)) {
    //            isForOrlando = true;
    //            eventLocation = "2500 south kirkman rd Orlando FL 32811";
    //            eventDate = "Saturday December 23, 2023 from 9am-11am";
    //            mapImage = "\\Documents\\orlando_wallmart.png";
    //            mapPath = "https://maps.app.goo.gl/7g2XuvJvJtZuUFGy5";
    //        }

    //        var params = {
    //            applicationId: item.applicationId, Status: key, updatedByName: loggedInUserName,
    //            isForOrlando: isForOrlando, eventLocation: eventLocation, eventDate: eventDate,
    //            mapImage: mapImage, mapPath
    //        }
    //        setIsLoading(true);
    //        PostDataAPI("everychildchristmas/approve", params, true).then((result) => {
    //            if (result.success) {
    //                showMessage("Success", "Application approved successfully", "success", 3000);
    //                loadApplicationsGrid();
    //            } else {
    //                showMessage("Error", result.message, "error", 3000);
    //            }
    //            setIsLoading(false);
    //        })
    //    });
    //}

    //const rejectApplicationForm = (applicationId, key) => {
    //    showActionDialog('Are you sure you want to reject this application?', "confirm", function () {
    //        var params = { applicationId: applicationId, Status: key, updatedByName: loggedInUserName }
    //        setIsLoading(true);
    //        PostDataAPI("everychildchristmas/reject", params, true).then((result) => {
    //            if (result.success) {
    //                showMessage("Success", "Application rejected successfully", "success", 3000);
    //                loadApplicationsGrid();
    //            } else {
    //                showMessage("Error", result.message, "error", 3000);
    //            }
    //            setIsLoading(false);
    //        })
    //    });

    //}

    const handlePrint = (_htmlContent) => {
        // Create a new window or tab
        const newWindow = window.open('', '_blank');

        // Write your HTML content to the new window
        newWindow.document.open();
        newWindow.document.write(_htmlContent);
        newWindow.document.close();
    }

    const [totalRecord, setTotalRecord] = useState();
    const [filteredApplicationsData, setFilteredApplicationsData] = useState();
    const [filteredStatus, setFilteredStatus] = useState("Subscribed");

    const handleStatusClick = (event, status) => {
        //var lstStatus = filteredStatus;
        //if (event.target.checked) {
        //    lstStatus.push(status);
        //}
        //else {
        //    lstStatus = lstStatus.filter(s => s != status)
        //}
        setFilteredStatus(status);
        //if (lstStatus.length > 0) {
        if (!status || status == 'Total') {
            setFilteredApplicationsData(applicationsData);
        } else {
            setFilteredApplicationsData(applicationsData.filter(o => status == o.status));
        }
        //}
        //else {
        //    setFilteredApplicationsData(applicationsData);
        //}

        handleDataGridUpdate();
    }

    const loadApplicationsGrid = () => {

        setIsLoading(true);
        //var param = [filter ? filter : filters.salesFilter];
        PostDataAPI("fdnsubscriber/loadGrid").then((result) => {
            setIsLoading(false);
            if (result.success && result.data) {
                console.log(result.data)
                setTotalRecord(result.data)
                var record = result.data.map((item, i) => {
                    item.phone = formateMdnNumber(item.phone);
                    item.status = item.isActive ? 'Subscribed' : 'Unsubscribed';
                    item.updateDate = item.updateDate ? formatDateTime(item.updateDate) : formatDateTime(item.createDate);
                    //item.applicationStatus = item.status;

                    return { ...item };
                })
                setApplicationsData(record);
                if (filteredStatus == "Total")
                    setFilteredApplicationsData(record);
                else
                    setFilteredApplicationsData(record.filter(item => item.status == filteredStatus));
                handleDataGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }

        });
    }

    const getRequestStatusCount = (status) => {
        var count = 0;
        if (status == 'Total') {
            count = totalRecord?.length
        }
        else if (status == 'Subscribed') {
            count = totalRecord?.filter(t => t.isActive).length
        } else if (status == 'Unsubscribed') {
            count = totalRecord?.filter(t => !t.isActive).length
        }
        return count;
    }
    const [applicationsCount, setApplicationsCount] = useState({});

    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();

    };
    useEffect(() => {
        loadApplicationsGrid();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Subscribers"} isBack={false} ></Breadcrums>
                    </Grid>
                </Grid>

            </div>



            <Grid container row className={classes.container}>

                <div className={classes.statusBoxContainer}>

                    {applicationsStatusBoxes.map((item, i) => (
                        <>
                            <FormControlLabel
                                className={classes.checkBoxFormLabel}
                                control={
                                    <Checkbox
                                        name="checkedB"
                                        color="primary"
                                        className={classes.checkBoxBtn}
                                        onClick={(e) => { handleStatusClick(e, item.status) }}
                                        checked={filteredStatus === item.status}
                                    />
                                }
                                label={<>
                                    <div className={item.status == "Total" ? classes.statusBoxes + " " + "Total" :
                                        item.status == "Subscribed" ? classes.statusBoxes + " " + "Pending" :
                                            classes.statusBoxes + " " + "Rejected"

                                    }>

                                        <div className={classes.statusBoxContent}>
                                            <span style={{
                                                fontSize: '35px',
                                                color: 'white'
                                            }} >
                                                {getRequestStatusCount(item.status)} </span>
                                            <h3>{item.value}

                                            </h3>
                                        </div>
                                        <img src={item.Icon} alt="" />

                                    </div>
                                </>}
                            />
                        </>
                    ))}

                </div>

            </Grid>

            <Grid row className={classes.gridHeader}>
                <div className={classes.labelBullet}>

                    {Object.entries(applicationsCount).map(([appCount, count]) => (
                        <li key={appCount}>
                            {!appCount ? 'Other' : appCount}: {count}
                        </li>
                    ))}

                </div>
                <Button className={classes.changeBtn} onClick={loadApplicationsGrid}>Refresh</Button>
                <Button className={classes.changeBtn} onClick={exportList}>Export</Button>


                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                    />

                </div>





            </Grid>

            <Grid row className={classes.container} >
                <SearchGrid columns={"Subscribers"}
                    list={filteredApplicationsData}
                    noRecordMsg="No record exists."
                    Icon={true}
                    filter={searchFilter}
                    isUpdate={isDataGridUpdate}
                    onActionClick={handleActionClick}
                    isTopPagination={true}
                />
            </Grid>


            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />


        </>
    )

}

export default withSnackbar(Subscribers);